// extracted by mini-css-extract-plugin
export const base = "styles-module--base--7udY8";
export const icon = "styles-module--icon--E99+e";
export const searchRoot = "styles-module--searchRoot--Jg8Zs";
export const search = "styles-module--search--BtKdw";